import { node, object, string } from "prop-types";
import { forwardRef } from "react";

import styled from "styled-components";

import FnrIcon from "UI/FnrIcon";

import useHeight from "Utilities/Hooks/useHeight";
import dynTop from "Utilities/interpolations/dynTop";

const DefaultIcon = forwardRef(({ icon, children, inputRef, ...rest }, ref) => {
  const inputHeight = useHeight(inputRef);
  if (!icon) return null;
  return (
    <IconWrapper
      data-cy="FnrInput_IconWrapper"
      ref={ref}
      $top={inputHeight ? inputHeight / 2 : "50%"}
      {...rest}
    >
      <FnrIcon icon={icon} />
    </IconWrapper>
  );
});

const IconWrapper = styled.div`
  position: absolute;
  transform: translateY(-50%);
  ${dynTop}
  color: #2867ac;
  font-size: 21px;
  width: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

DefaultIcon.propTypes = {
  icon: string,
  inputRef: object,
  children: node,
};

export default DefaultIcon;
